import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { digitsOnly, luhnValidate } from './validation.utils';

export interface BankgiroErrors {
  invalidBankgiro?: true;
  invalidBankgiroMessage?: string;
}

export function isValidBankgiro(value: string | null | undefined): boolean {
  const digits = digitsOnly(value);

  if (digits.length !== 7 && digits.length !== 8) {
    return false;
  }

  return luhnValidate(digits);
}

export function formatBankgiro(value: string | null | undefined): string {
  const digits = digitsOnly(value);

  if (!digits) {
    return '';
  }

  if (digits.length === 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  }

  return digits;
}

export const bankgiroValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = (control.value ?? '').toString().trim();

  if (!raw) {
    return null;
  }

  const digits = digitsOnly(raw);

  if (digits.length !== 7 && digits.length !== 8) {
    return {
      invalidBankgiro: true,
      invalidBankgiroMessage: 'Kontrollera numret, det brukar ha 7-8 siffror med korrekt kontrollsiffra'
    };
  }

  if (!isValidBankgiro(digits)) {
    return {
      invalidBankgiro: true,
      invalidBankgiroMessage: 'Kontrollera numret, det brukar ha 7-8 siffror med korrekt kontrollsiffra'
    };
  }

  return null;
};